<template>
  <div class="m-login__signin flipInX animated">
    <div class="m-login__head">
      <h3 class="m-login__title">Logowanie</h3>
    </div>
    <div v-if="!selfRegistration" class="alert m-alert--default mt-4" role="alert">
      <div class="m-alert__text">
        <strong>Logujesz się pierwszy raz?</strong>
        <p class="no-margin">
          Musisz najpierw ustawić hasło <a class="m-link m-link--state m-link--ls"
                                           @click="setSetPasswordForm">klikając tutaj</a>.
        </p>
      </div>
    </div>

    <login-alert/>

    <div class="m-login__form m-form">
      <div class="form-group m-form__group">
        <input class="form-control m-input" type="text" placeholder="E-mail" name="email"
               v-model="email"
               @keyup.enter="debounceLogin"
               autocomplete="off">
      </div>
      <div class="form-group m-form__group">
        <input class="form-control m-input m-login__form-input--last" type="password" placeholder="Hasło"
               v-model="password"
               @keyup.enter="debounceLogin"
               name="password">
      </div>
      <div class="row m-login__form-sub">
        <div v-if="selfRegistration" class="col m--align-left">
          <a id="m_login_sign_up" class="m-link m-link--state m-link--ls"
             @click="setSignUpForm">Zarejestruj się</a>
        </div>
        <div class="col m--align-right">
          <a id="m_login_forget_password" class="m-link m-link--state m-link--ls"
             @click="setForgotPasswordForm">Zapomniałeś hasła?</a>
        </div>
      </div>
      <div class="m-login__form-action mt-5 mb-4">
        <button id="m_login_signin_submit" class="btn m-btn m-btn--pill m-btn--custom m-btn--air btn-ls"
                @click="debounceLogin">
          Zaloguj się
        </button>
        <button v-if="isAnyExternalLoginEnabled" id="m_login_forget_password_cancel"
                class="btn m-btn m-btn--pill m-btn--custom btn-outline-ls m-btn--hover-ls mb-2"
                @click="setSelectForm">
          Anuluj
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import debounce from 'lodash.debounce'
import {SELF_REGISTRATION_NO} from '@/utils/SelfRegistrationTypes';
import LoginAlert from "@/components/login/LoginAlert";
import ExternalLogin from "@/mixins/externalLogin";

export default {
  name: "SignInForm",
  components: {LoginAlert},
  mixins: [ExternalLogin],
  data() {
    return {
      email: '',
      password: ''
    }
  },
  created() {
    if (this.$route.query.email) {
      this.email = this.$route.query.email;
    }
    if (this.$route.query.password) {
      this.password = this.$route.query.password;
    }
  },
  destroyed() {
    this.clearLoginInfo();
    this.clearLoginError();
  },
  methods: {
    ...mapActions([
      'login',
      'setSelectForm',
      'setSetPasswordForm',
      'setSignUpForm',
      'setForgotPasswordForm',
      'clearLoginError',
      'clearLoginInfo'
    ]),
    debounceLogin: debounce(function () {
      this.login({
        login: this.email,
        password: this.password,
      })
    }, 300)
  },
  computed: {
    ...mapState({
      selfRegistration: state => state.settings.selfRegistration !== SELF_REGISTRATION_NO,
      externalLogin: state => state.settings.externalLogin,
    }),
  }
}
</script>

<style scoped>
.m-link {
  color: rgb(113, 106, 202) !important;
  cursor: pointer;
}

.alert-dismissible {
  padding-right: 3rem !important;
}

.no-margin {
  margin: 0 !important;
}

.m-link.m-link--ls {
  color: var(--accent-color) !important;
}

.m-link.m-link--ls:hover::after {
  border-bottom: 1px solid var(--accent-color);
  opacity: .3;
}
</style>
